/* eslint-disable */
import React, { useCallback, useEffect } from "react";
import { connect } from "react-redux";
import { useLocation } from 'react-router-dom'
import LoginView from "views/Login";
import AuthService from "api/Auth";
import UserService from "api/User";
import UserActions from "store/reducers/User";
import SettingsActions from "store/reducers/Settings";
import { handlePromise, storage } from "utils";



function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const Login = ({
  locale,
  toggleLoading,
  switchLanguage,
  alternateAppLoginData,
  history,
}) => {



  let query = useQuery();
  var params = query.get('language')
  console.log('params: ', params);

  const Language = (lang) => {
    if (lang) {
      locale = lang.toLowerCase();
    } else {
      locale = "en";
    }
    switchLanguage({
      locale: locale == "en" ? "en" : "es",
      name: locale == "en" ? "english" : "spanish",
    });
  };

  useEffect(() => {
  var params = query.get('language')
    console.log("hello",params)
    try {
      if (params) {
        Language(params);
      }
    } catch (error) {}
  }, []);


  const submitForm = useCallback(
    async (formData) => {
      toggleLoading(true);

      const error = (errorMsg) => {
        toggleLoading(false);
        var errMsg = errorMsg
          .replace(/<[^>]*>?/gm, "")
          .replace(/\s+/g, " ")
          .trim();
        if (
          errMsg.toLowerCase() ===
          "Invalid username and password combination".toLowerCase()
        ) {
          return "invalidUsernameAndPasswordCombination" || "apiError";
        } else {
          return errorMsg || "apiError";
        }
      };

      const [loginErrors, loginResponse, loginData] = await handlePromise(
        AuthService.loginUser(formData)
      );
      if (!loginResponse.ok) return error(loginErrors);
      storage.set("massphoningout:token", loginData.access_token);

      const [, userResponse, userData] = await handlePromise(
        UserService.getUser()
      );
      if (
        !userResponse.ok ||
        !userData.roles ||
        (userData.roles.indexOf("ROLE_CUSTOMER") === -1 &&
          userData.roles.indexOf("ROLE_CUSTOMER_ADMIN") === -1)
      ) {
        storage.clear("massphoningout:token");
        return error("apiError");
      }

      const [, statusResponse, statusData] = await handlePromise(
        UserService.getStatus()
      );

      if (
        !statusResponse.ok ||
        !statusData.result ||
        (statusData.result == false)
      ) {
        storage.clear("massphoningout:token");
        return error("accountDeactive");
      }

      if (userData.language) {
        switchLanguage({
          locale: userData.language === "es" ? "es" : "en",
          name: userData.language === "es" ? "spanish" : "english",
        });
      }

      alternateAppLoginData({
        ...loginData,
        email: userData.email,
        firstName: userData.firstName,
        lastName: userData.lastName,
        roles: userData.roles,
        credit: userData.credit,
      });
      setTimeout(() => {
        toggleLoading(false);
        history.push("/auth/select-app");
      }, 100);
    },
    [toggleLoading, switchLanguage, alternateAppLoginData, history]
  );
  console.log("jwqdbwdvvd")

  return (
    <>
      <LoginView onSubmit={submitForm} />
    </>
  );
};
const mapStateToProps = ({ settings }) => ({ locale: settings.locale });

const mapDispatchToProps = {
  alternateAppLoginData: UserActions.alternateAppLoginData,
  toggleLoading: SettingsActions.toggleLoading,
  switchLanguage: SettingsActions.switchLanguage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
